import React, { useState } from 'react';
import { authAdminUpdate } from "../service/api";
import Card from "@material-ui/core/Card";
import SimpleModal from './ModalComponent/ModalComponent';
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CustomizedInputBase from "./CustomisedInput";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";

const AdminVehicleSearchUnground = (props) => {
  const [vinInput, setVinInput] = React.useState("");
  const [invalidVin, setInvalidVin] = React.useState('');
  const [openModal, setOpenModal] = useState(true);
  const handleSearch = (text) => {
  if(/^[a-zA-Z0-9]*$/.test(text) === false) {
    return setInvalidVin('Please Enter a Valid VIN');
  } else {
    setInvalidVin('');
  }
    setVinInput(text);
  }
  const modalCancelHandle = () => {
    props.history.push("/notAuthorized", {
      pageName: "notAuthorized",
    });
  }
  const modalOkHandle = async (e) => {
    if(e) {
       const data = await authAdminUpdate(e);
       if (data && data?.data === 'TRUE') {
        setOpenModal(false);
      } else {
        modalCancelHandle()
      }
    }    
  };

  const handleSubmitbtn = (searchText, submitClck) => {
    const vinSearch = submitClck ? vinInput : searchText;
    if (vinSearch.length < 17) {
      setInvalidVin('Please Enter a Valid 17 Digit VIN');
    }
    if (vinSearch && vinSearch?.length === 17) {
      props.history.push("/adminSearchResult", {
        vin: vinSearch,
        isUnground : true
      });
    }
  };

  return (
    <>
      {openModal ?
        <div style={{ marginTop: '50px' }}>
          <SimpleModal
                        show={openModal}
                        okButtonHandler={(e) => modalOkHandle(e)}
                        cancelButtonHandler={modalCancelHandle}
                        color="#CC0000"
                        size="7x"
                        displayText1="Enter the Admin authorization keyword."
                        textFieldPlaceHolderText="Admin authorization keyword..."
                        buttonText1="CANCEL"
                        buttonText2="OK">
                        error
                    </SimpleModal></div>: 
    <div style={{ marginTop: '50px' }}>
    <Card className="adminSearchCard">
      <CardContent className="adminSearcheader">
        <img className="cover" alt="cover" src="searchCar.png" />
        <div className="adminSearcheaderColor">
          <Typography variant="h4" component="h4">
            Vehicle Search
          </Typography>
          <Typography variant="p" component="p">
            Search for a vehicle, or start with any of the menu items on the
            left.
          </Typography>
        </div>
      </CardContent>
      <Divider />
      <CardContent className="adminSearchCardBody">
        <div>
        <CustomizedInputBase
          searchdetails={(SearchText) => handleSearch(SearchText)}
          onEnterKeyDown={(SearchText) => handleSubmitbtn(SearchText)}
          setInvalidVin={(errorText) => setInvalidVin(errorText)}
        />
        { invalidVin && <Typography style={{color: 'red'}} component="p">{invalidVin}</Typography>}
          </div>
        <Button variant="contained" style={{height: '38px'}} onClick={() => handleSubmitbtn('', true)} color="primary">
          Submit
        </Button>
      </CardContent>
    </Card>
    </div>}
    </>
  );
};
export default AdminVehicleSearchUnground;
